// How long ago something on the floor happened — a call for help (spec/13 §3.2, F-SES-25). Minutes for
// the first hour, then hours for the first day, then days: a call left open overnight reads "14 h ago",
// never "840 min ago".

type Translate = (key: string, options?: Record<string, unknown>) => string;

const MINUTE_MS = 60_000;
const HOUR_MINUTES = 60;
const DAY_MINUTES = 24 * HOUR_MINUTES;

/** "just now", "3 min ago", "5 h ago", "2 d ago". An unreadable time is shown as it came. */
export function formatAgo(iso: string, t: Translate, now: number): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return iso;
  const minutes = Math.max(0, Math.floor((now - then) / MINUTE_MS));
  if (minutes < 1) return t('floor.calls.justNow');
  if (minutes < HOUR_MINUTES) return t('floor.calls.ago', { minutes });
  if (minutes < DAY_MINUTES) return t('floor.calls.agoHours', { hours: Math.floor(minutes / HOUR_MINUTES) });
  return t('floor.calls.agoDays', { days: Math.floor(minutes / DAY_MINUTES) });
}
